export default "../media/loading_gif.63bf954d7cb2a6e60563dc7765d0859c.gif";